"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_router_dom_1 = require("react-router-dom");
var react_2 = require("@chakra-ui/react");
var routes_1 = __importDefault(require("./routes"));
var theme_1 = __importDefault(require("./theme/theme"));
var App = function () {
    var themeData = (0, react_2.extendTheme)(theme_1.default);
    return (react_1.default.createElement(react_2.ChakraProvider, { theme: themeData },
        react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement(routes_1.default, null))));
};
if (document.getElementById("app")) {
    react_dom_1.default.render(react_1.default.createElement(App, null), document.getElementById("app"));
}
